import React from 'react'; // Removed useEffect, useState
import { Link } from 'react-router-dom';
import 'babel-polyfill';
import { IProvider } from './interfaces'; // Removed Coords as it's not used
import MiniSchedule from './minischedule';
// Removed map imports: MarkerClusterer, Cluster, googlemaps
import { addQueryParam, formatPhone } from './util';

interface IProps {
    providers: IProvider[];
    totalProviders: number;
    isLoading: boolean;
    reason: string;    
    apptType?: string;
    backto?: string;
    who?: string;
}

const VirtualistResults = (props: IProps) => {
    if (props.isLoading) {
        // Use a more visually centered loading indicator if preferred
        return (<div className="text-center p-5">Loading results...</div>);
    }

    if (!props.providers || props.providers.length === 0) { // Added check for undefined/null providers
        return (
            <div className="alert alert-warning"> {/* Use Bootstrap alert for visibility */}
                No providers found matching criteria. Please try a <a href={`./#reason=${props.reason}`}>new search</a>
                {props.totalProviders >= 0 && " or adjust your filters."} {/* Modified text slightly */}
            </div>
        );
    }

    return (
        // Removed container div, parent component now handles layout columns
        <div> {/* Replace container with a simple div or React.Fragment */}
            {props.providers.slice(0, 50).map((p, i, a) => {
                // Ensure params are correctly formed
                const providerParamsObj = {
                    npi: p.npi,
                    deptid: p.departmentId,
                    backto: props.backto,
                    //...(props.apptType && { apptType: props.apptType }) 
                };
                // Filter out undefined/null values before creating query string
                const validParams = Object.entries(providerParamsObj)
                    .filter(([_, value]) => value != null)
                    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);

                const providerParams = `?${validParams.join('&')}`;


                return (
                    // Use React.Fragment shorthand <>...</>
                    <React.Fragment key={p.npi + '-' + p.departmentId}> {/* More specific key */}
                        <div className="row mb-5 search-result-item" /* Removed map hover events */ >
                            {/* Provider Info Column */}
                            <div className="col-lg-7"> {/* Adjusted column size potentially */}
                                <div className="d-flex align-items-start"> {/* Use flexbox for alignment */}
                                    {/* Image & Badges */}
                                    <div className="flex-shrink-0 mr-3" style={{ maxWidth: "120px", marginRight: "20px" }}>
                                        <Link to={{ pathname: "/provider", search: providerParams }}>
                                            {/* Conditional rendering for photo */}
                                            <img
                                                className="py-1 img-fluid rounded" /* Added Bootstrap image classes */
                                                src={(window as any).PHOTO_URL + (p.photo ? p.photo : (p.gender === "M" ? "m00000000.jpg" : "f00000000.jpg"))}
                                                alt={`${p.firstName} ${p.lastName}`} /* Add alt text */
                                                width="120"
                                            />
                                        </Link><br />
                                        {/* Ensure languageList exists */}
                                        {p.languageList && p.languageList.map(l => (
                                            <span key={l} className="badge bg-secondary me-1 mb-1" style={{ color: "white" }}>{l}</span>
                                        ))}
                                    </div>

                                    {/* Text Details */}
                                    <div className="flex-grow-1">
                                        <h4 className="provider-name mb-1 h5"> {/* Use h4/h5 for better hierarchy */}
                                            <Link to={{ pathname: "/provider", search: providerParams }} className="text-decoration-none"> {/* Remove underline */}
                                                {p.firstName + " " + p.lastName}{p.academicTitle && (", " + p.academicTitle)}
                                            </Link>
                                        </h4>
                                        <p className="mb-1">
                                            <div className="mb-1">
                                                {p.clinic && <><span className="fw-bold">{p.clinic}</span><br /></>} {/* Highlight clinic name */}
                                                {p.clinicOldName && <span style={{ fontSize: "80%" }}><em>formerly {p.clinicOldName}</em><br /></span>}
                                            </div>
                                            
                                            {/* Ensure phone number exists before formatting/linking */}
                                            {p.phone && <>Phone: <a href={"tel:" + formatPhone(p.phone)}>{formatPhone(p.phone)}</a></>}
                                        </p>
                                        {p.virtualVisit && <div className="text-success small mt-1"><img src="img/icon_vv.png" width="15" alt="Offers Virtual Visits" title="Offers Virtual Visits" style={{ display: "inline-block", verticalAlign: "text-bottom", marginRight: '4px' }} /> Offers Virtual Visits</div>} {/* Improved VV display */}
                                    </div>
                                </div>
                            </div>

                            {/* Schedule Column */}
                            <div className="col-lg-5 mt-3 mt-lg-0"> {/* Adjusted column size, added top margin on smaller screens */}
                                <MiniSchedule key={p.npi + "-schedule"} clinic={p.clinic} phone={formatPhone(p.phone)} availability={p.availability} npi={p.npi} deptid={p.departmentId} apptType={props.apptType} reason={props.reason} backto={props.backto} who={props.who} />
                                {/* Simplified the more details link */}                                
                                <div className="text-right mt-2" style={{ fontSize: "90%", paddingRight: "15px" }}>
                                    <Link to={{ pathname: "/provider", search: providerParams }} className="btn btn-outline-secondary btn-sm">
                                        View Details & Schedule
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {(i < (a.length - 1)) && <hr className="my-4" />} {/* Use my-4 for margin */}
                    </React.Fragment>
                );
            })}
        </div>
    );
}

export default VirtualistResults;